export function isLocalDevelopment(): boolean {
  return ['local', 'frontend'].includes(__stage);
}
